"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bcp_1 = require("@iov/bcp");
const crypto_1 = require("@iov/crypto");
function prehash(bytes, type) {
    switch (type) {
        case bcp_1.PrehashType.None:
            return new Uint8Array([...bytes]);
        case bcp_1.PrehashType.Sha256:
            return new crypto_1.Sha256(bytes).digest();
        case bcp_1.PrehashType.Sha512:
            return new crypto_1.Sha512(bytes).digest();
        case bcp_1.PrehashType.Keccak256:
            return new crypto_1.Keccak256(bytes).digest();
        default:
            throw new Error("Unknown prehash type");
    }
}
exports.prehash = prehash;
//# sourceMappingURL=prehashing.js.map